import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContent,[_c(VContainer,{attrs:{"fluid":"","fill-height":""}},[_c(VLayout,{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c(VFlex,{attrs:{"xs12":"","sm6":"","md4":""}},[_c('fcc-new-password')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }